import { Pencil, Trash2, Volume2 } from "lucide-react";
import { SpecimenIcon } from "../../lib/icons";
import { playVoice } from "../../lib/voice";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

const Row = ({ s, readOnly, onEdit, onDelete }) => (
  <tr data-testid={`specimen-row-${s.slot}`} className="border-b border-slate-800/80 hover:bg-slate-900/60 transition-colors">
    <td className="py-3 pl-4 font-mono text-slate-500">#{String(s.slot).padStart(2, "0")}</td>
    <td className="py-3"><SpecimenIcon name={s.icon} size={22} className="text-emerald-300" /></td>
    <td className="py-3 font-semibold text-slate-100">{s.name}</td>
    <td className="py-3 font-mono tracking-widest text-cyan-300">{s.spore_word}</td>
    <td className="py-3">
      <button data-testid={`specimen-play-${s.slot}`} onClick={() => playVoice(s.voice, s.sound_word, s.spore_word)} className="flex items-center gap-2 font-mono text-xs text-emerald-300 hover:text-emerald-100 transition-colors" title="Play voice">
        <Volume2 size={13} /> {s.sound_word || "-"}
      </button>
    </td>
    <td className="py-3 font-mono text-xs text-slate-400">{s.tag_uid}</td>
    {!readOnly && (
      <td className="py-3 pr-4">
        <div className="flex justify-end gap-2">
          <button data-testid={`specimen-edit-${s.slot}`} onClick={() => onEdit(s)} className="lab-icon-btn h-8 w-8"><Pencil size={14} /></button>
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <button data-testid={`specimen-delete-${s.slot}`} className="lab-icon-btn h-8 w-8 hover:!border-rose-400 hover:!text-rose-400"><Trash2 size={14} /></button>
            </AlertDialogTrigger>
            <AlertDialogContent className="lab-dialog">
              <AlertDialogHeader>
                <AlertDialogTitle className="font-display uppercase tracking-widest">Remove {s.name}?</AlertDialogTitle>
                <AlertDialogDescription className="text-slate-400">The tag will no longer be recognised by the kiosk.</AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel className="lab-btn-ghost">Cancel</AlertDialogCancel>
                <AlertDialogAction data-testid={`specimen-delete-confirm-${s.slot}`} className="lab-btn-danger" onClick={() => onDelete(s)}>Remove</AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </td>
    )}
  </tr>
);

export const SpecimenTable = ({ specimens, readOnly = false, onEdit, onDelete }) => {
  const heads = ["Slot", "Icon", "Object", "Hive word", "Sound", "Tag ID", ...(readOnly ? [] : [""])];
  return (
    <div className="overflow-x-auto border border-slate-800 bg-slate-950/70">
      <table data-testid="specimen-table" className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-cyan-400/20">
            {heads.map((h, i) => (
              <th key={i} className={`lab-label py-3 font-normal ${i === 0 ? "pl-4" : ""}`}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {specimens.map((s) => <Row key={s.id} s={s} readOnly={readOnly} onEdit={onEdit} onDelete={onDelete} />)}
        </tbody>
      </table>
      {specimens.length === 0 && <p data-testid="specimen-empty" className="p-8 text-center font-mono text-slate-500">No objects programmed yet. Use the Bench tab.</p>}
    </div>
  );
};
